<template>
  <span v-show="false" aria-hidden="true" />
</template>

<script>
import {
  acquireGlobalLoader,
  releaseGlobalLoader,
} from "@/utils/globalLoader.js";

export default {
  name: "Overlay",

  props: {
    overlay: Boolean,
  },

  data: () => ({
    held: false,
  }),

  watch: {
    overlay: {
      immediate: true,
      handler(active) {
        if (active && !this.held) {
          acquireGlobalLoader();
          this.held = true;
        } else if (!active && this.held) {
          releaseGlobalLoader();
          this.held = false;
        }
      },
    },
  },

  beforeUnmount() {
    if (this.held) {
      releaseGlobalLoader();
      this.held = false;
    }
  },
};
</script>
